import type { SectionProps, SectionsContentImage } from "../../../types";
import { contentImageVariant } from "./content-image.variants";

export type UseContentImageProps = SectionProps<SectionsContentImage>;

export const useContentImage = (props: UseContentImageProps) => {
  const { className = "", sectionName, data } = props;
  const { theme = "dark" } = data;

  const styles = contentImageVariant({ theme });

  return {
    sectionName,
    className,
    styles,
    data,
  };
};
